import { useEffect } from 'react';

export default ({ updateShowZipInput, zipLoad, zip }) => {
  useEffect(() => {
    if (!zipLoad) return;

    updateShowZipInput(!zip);
  }, [zipLoad, zip]);
};
